import { createAppInstance } from './app'
import { useSiteConfigStore } from './stores/SiteConfig'
import { useAuthStore } from './stores/UserAuth'
// 导入全局样式
import '@/assets/styles/main.scss'
// 导入资源路径修复工具
import { AssetPathFixerPlugin, fixAllResourcePaths } from './utils/AssetPathFixer'
// 导入客服统一调用模块
import { initializeCustomerService } from './utils/CustomerService'

createAppInstance().then(({ app, router }) => {

  // 初始化客服模块（仅客户端；提示使用默认浮层实现）
  initializeCustomerService()

  // 注册资源路径修复工具
  app.use(AssetPathFixerPlugin);

  if (window.__INITIAL_STATE__) {
    app.config.globalProperties.$store = window.__INITIAL_STATE__
    
    // 恢复服务端的认证状态
    if (window.__INITIAL_STATE__.auth) {
      const authStore = useAuthStore()
      authStore.$patch(window.__INITIAL_STATE__.auth)
    }
  }

  if (window.__INITIAL_SITE_CONFIG__) {
    const siteConfigStore = useSiteConfigStore()
    siteConfigStore.$patch(window.__INITIAL_SITE_CONFIG__)
  }

  // 读取SSR配置 - 从 window.__INITIAL_STATE__ 中获取
  const ssrConfig = window.__INITIAL_STATE__?.ssrConfig || { mode: 'spa' };
  
  // 在完全SSR模式下，每次路由变化都触发完整页面加载
  if (ssrConfig.mode === 'full') {
    // 存储已处理的路由，避免循环重定向
    const processedRoutes = new Set();
    
    // 记录当前路径，避免初始加载时重定向
    const currentPath = window.location.pathname;
    processedRoutes.add(currentPath);
    
    router.beforeEach((to, from, next) => {
      // 如果是初始加载或重复路由，直接放行
      if (from.name === null || to.path === from.path) {
        next();
        return;
      }
      
      // 防止无限循环
      if (processedRoutes.has(to.path)) {
        next();
        return;
      }
      
      // 记录已处理的路由
      processedRoutes.add(to.path);
      
      // 触发完整页面加载，走服务端渲染
      window.location.href = to.path;
      
      // 阻止客户端路由继续
      next(false);
    });
  }

  router.isReady().then(() => {
    app.mount('#app')
    
    // 应用挂载后全局扫描多次资源路径，确保所有动态加载的内容都被处理
    if (typeof fixAllResourcePaths === 'function') {
      // 初次扫描，处理首屏内容
      setTimeout(() => {
        fixAllResourcePaths(document.body);
      }, 500);
      
      // 再次扫描，处理可能的异步加载内容
      setTimeout(() => {
        fixAllResourcePaths(document.body);
      }, 1500);
      
      // 最后一次扫描，确保所有延迟加载内容都被处理
      setTimeout(() => {
        fixAllResourcePaths(document.body);
      }, 3000);
    }
  }) 
})
